import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import languageList from '../../assets/language/language.json'
import useHttp from "../../axios/useHttp";
import endpoints from "../../axios/endPoints";
import useWindowSize from "../../Hooks/useWindowSize";
import { 
  Container,
  LoginSectionWrapper,
  ChartTitle,
  Label,
  TopLabel,
  BottomText,
  HistoricalContainer,
  LeftTab,
  HistoricalLabel,
  RightTab,
  Underlying,
  Circle,
  SelectField,
  Year,
  ChartContainer,
  VerticalText,
  ChartWrapper,
  OptionField,
  OptionSpan,
  Divider,
  CustomOverlay,
  EmptyDataContainer
} from "./Login.style";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const AnnualReport = () => {

  const navigate = useNavigate();

  const windowSize = useWindowSize();
  const [searchParams] = useSearchParams();
  const { language } = useParams();
  const { get } = useHttp();
  const [productName, setProductName] = useState(undefined)
  const [languages, setLanguage] = useState(null)
  const [shareClass, setShareClass] = useState([])
  const shareClassParam = searchParams.get("share_class") || null;
  const [labels, setLabelList] = useState([])
  const [dataSet, setDataSet] = useState([])
  const [isLoading, setLoading] = useState(false)
  const [noDataMsg, setNoDataMsg] = useState(null)
  const [fundStartDate, setFundStartDate] = useState(null)
  useEffect(() => {
      getShareClass()
  }, [])


  const getShareClass = async () => {

      setLoading(true)
      try {
          const response = await get({endpoint: endpoints.getShareClass});
          if(response && !shareClassParam){
            setProductName(response[0]?.share_class_isin)
          }
          setShareClass(response)
          setLoading(false)
      } catch (err) {
        setLoading(false)
      }
  }

  useEffect(() => {
    if(languageList[language]){
      setLanguage(languageList[language])
    } else {
      setLanguage(languageList['en'])
    }

  }, [language])

  useEffect(() => {
    if(shareClassParam){
      setProductName(shareClassParam)
    }
}, [shareClassParam])

  const handleChange = (event) => {
    const { value } = event.target;
    setProductName(value);
  }

  useEffect(() => {
    if(productName){
      fetchAnnualData()
    }
  }, [productName])

  const fetchAnnualData = () => {
    getAnnualData()
  }

  const getAnnualData = async () => {
    setLoading(true)
    try {
        const response = await get({endpoint: `${endpoints.getAnnualPerformance}/${productName}`});
        const labelArray = []
        const dataArray = []
        if(response){
          if(response?.message){
            setNoDataMsg(response?.message)
          } else {
            if(response?.data){
              setNoDataMsg(null)
              response?.data?.map(singleRow =>{
                  labelArray.push(singleRow?.year)
                  let valLabel = parseFloat(singleRow?.value)
                  if(valLabel){
                    dataArray.push(valLabel.toFixed(2))
                  } else {
                    dataArray.push(0)
                  }
              })
              setLabelList(labelArray)
              setDataSet(dataArray)
            } else {
              setLabelList([])
              setDataSet([])
            }
          }

          if(response?.fund_start_date){
            setFundStartDate(response?.fund_start_date)
          } else {
            setFundStartDate(null)
          }
          setLoading(false)
        }
    } catch (err) {
      setLoading(false)
      setNoDataMsg(languages?.no_data)
    }
}



const data = {
  labels,
  datasets: [
    {
      label: '',
      data: dataSet,
      backgroundColor: '#0096FF',
      barThickness: windowSize?.width < 600 ? 10 : 20,
      barPercentage: 1,
    },
  ]
};

const getOptions = () => {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        display: false
      },
      title: {
        display: false,
        text: '',
      },
      tooltip: {
        displayColors:false,
        callbacks: {
          title: (xDatapoint) => {return false},
          label: (yDatapoint) => {
          return ((yDatapoint.raw) + '%')
        },
        }
      }
      
    },
    scales: {
      x: {
        display: true,
        grid: {
          display: false
        }
      },
      y: {
        border:{
          dash: [3, 3], 
          display: false },
        ticks: {
          beginAtZero: true,
          callback: function(value) {
            return `${value?.toFixed(2)} %`;
          }
        },
        beginAtZero: true,
      }
    },
    onClick: (evt, element) => {
      if(element.length > 0) {
          console.log(evt, element)
      }}
  };

  return options
}

const getFormattcedFund = (fDat)=> {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May","Jun","Jul", "Augt", "Sep", "Oct", "Nov","Dec"];
  if(fDat){
    const d = new Date(fundStartDate);
    return monthNames[d?.getMonth()]+', '+d?.getFullYear()
  } else {
    return null
  }
 
}

  return (
    <Container height={windowSize?.width < 1200 ? windowSize?.height : null}>
      {isLoading && <CustomOverlay>
        <img src="/images/loader.gif" alt="Loader" />
      </CustomOverlay>}
      <LoginSectionWrapper>
          <ChartTitle>{`${languages?.fund_details}`}</ChartTitle>
          <HistoricalContainer> 
              <LeftTab>
                <TopLabel>{languages?.international_funds}</TopLabel>
                <HistoricalLabel>{languages?.historical_returns}</HistoricalLabel>
                {getFormattcedFund(fundStartDate) && <Label>{`${languages?.fund_launched} ${getFormattcedFund(fundStartDate)}`}</Label>}
              </LeftTab>
              <RightTab>
                   <SelectField
                        disabled={false}
                        id="role"
                        name="role"
                        className="product-select"
                        placeholder="Product Name"
                        value={productName}
                        onChange={handleChange}
                    >
                        <OptionField className="option-text" value="">{languages?.select}</OptionField>
                      {shareClass?.map(single => (
                          <OptionField key={single?.share_class_isin} value={single?.share_class_isin}>{single?.share_class_name?.toUpperCase()}</OptionField>
                          ))}
                    </SelectField>
                  
                <Underlying>
                  <Circle />
                  <Label>{languages?.underlying}</Label>
                </Underlying>
              </RightTab>
          </HistoricalContainer>
          <Divider />
          <ChartContainer>
            <VerticalText type={'year'}>
              {languages?.annual_return}
            </VerticalText>
            <ChartWrapper>
              <Bar options={getOptions()} data={data} />
             {(!isLoading && dataSet?.length === 0) && <EmptyDataContainer>
                {fundStartDate ? `${languages?.empty_data} ${getFormattcedFund(fundStartDate)} ${languages?.empty_data_1}` : languages?.no_data}
              </EmptyDataContainer>}
            </ChartWrapper>

          </ChartContainer>
        
          <Year>{languages?.years}</Year>
      </LoginSectionWrapper>
      <BottomText>
        {languages?.policy}
      </BottomText>
    </Container>
  );
};

export default AnnualReport;
